import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M20.666 10.378a10.6 10.6 0 0 1 .156 1.83c0 2.737-.979 5.053-2.682 6.62h.002C16.653 20.203 14.606 21 12.178 21a9 9 0 0 1 0-18 8.65 8.65 0 0 1 6.02 2.343l-2.569 2.57a4.89 4.89 0 0 0-3.451-1.35c-2.348 0-4.342 1.583-5.053 3.716a5.39 5.39 0 0 0 0 3.446h.003c.714 2.13 2.706 3.713 5.053 3.713 1.213 0 2.255-.31 3.063-.86h-.004a4.163 4.163 0 0 0 1.799-2.734h-4.861V10.38h8.488Z"
    />
  </svg>
`;
